import React, {
  createContext, useContext, useCallback, useRef, useState, ReactNode,
} from 'react';
import { Toast } from '../ui';
import { I } from '../icons-ds';

type ToastState = { message: string; visible: boolean };

type ToastContextValue = {
  showToast: (message: string) => void;
};

const ToastContext = createContext<ToastContextValue | null>(null);

export function ToastProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<ToastState>({ message: '', visible: false });
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const showToast = useCallback((message: string) => {
    if (timer.current) clearTimeout(timer.current);
    setState({ message, visible: true });
    timer.current = setTimeout(() => {
      setState((s) => ({ ...s, visible: false }));
    }, 1800);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Toast visible={state.visible} icon={<I.check size={16} stroke={2.4} />}>
        {state.message}
      </Toast>
    </ToastContext.Provider>
  );
}

export function useToast(): ToastContextValue {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used within a ToastProvider');
  return ctx;
}
